import { Exercise, ExerciseType } from '@/models/LearnTypes';
import { Word } from '@/models/Lesson';

export const generateExercisesForLevel = (
  levelType: ExerciseType, 
  words: Word[], 
  skipShuffle = false,
  level = 1
): Exercise[] => {
  if (!words || words.length === 0) {
    console.error("No words found to generate exercises");
    return [];
  }
  
  console.log(`Generating exercises for level type: ${levelType} with ${words.length} words`);
  const shuffledWords = skipShuffle ? words : [...words].sort(() => Math.random() - 0.5);
  
  const exercises = shuffledWords.map(word => ({
    id: word.id,
    type: levelType,
    word: word.word,
    translation: word.translation,
    level: level
  }));
  
  console.log(`Generated ${exercises.length} exercises`);
  return exercises;
};
